import style from "./HeaderFooterLayout.module.css"
import Footer from "./Footer"

const HeaderFooterLayout = ({ children, hideFooter = false, style: containerStyle, contentStyle }) => (
    <div className={style.container} style={containerStyle}>
        <div className={style.content} style={contentStyle}>{children}</div>
        {!hideFooter && <Footer />}
    </div>
)

export default HeaderFooterLayout
